import React from "react"
import PropTypes from "prop-types"
import "./marketing-bt-2.scss"
import Button from "../shared/button/text-button"

const MarketingBT2 = ({ handleButtonClick, handleBackButtonClick }) => (
  <div className="marketing-page-container">
    <div className="marketingPage marketing-page--bt">
      <div className="row resize-text">
        <img
          className="main-size"
          src="images/marketing/BT_woman_2.jpeg"
          width="100%"
          alt=""
        />
        <img
          className="phone-size"
          src="images/marketing/BT_family.jpg"
          width="100%"
          alt=""
        />
        <div className="text-image">
          <strong>BT broadband goes even further -​</strong>
          <br /> beyond fast, reliable and safe with brilliant, expert customer
          service.
        </div>
      </div>
      <div className="row spacing">
        <div className="columns vertical-line">
          <div className="logo">
            <img src="images/marketing/BT_lightning.png" alt="" />
          </div>
          <h3>Beyond Fast</h3>
          <p>
            <strong>The UK’s biggest Full Fibre provider</strong>
          </p>
          <p>
            Always reliable superfast speeds as standard. And, we’re bringing
            the next generation of fibre to the UK. We call it Full Fibre and
            its unimaginably reliable with gigafast speeds of 900 Mbps. A total
            game changer.
          </p>
          <p>
            <strong>Guaranteed speeds</strong>
          </p>
          <p>
            Always giving you the speeds we promise, or get £20 back with our
            Stay Fast Guarantee.
          </p>
        </div>
        <div className="columns vertical-line">
          <div className="logo">
            <img src="images/marketing/BT_shield.png" alt="" />
          </div>
          <h3>Beyond Safe</h3>
          <p>
            <strong>The UK’s most secure broadband</strong>
          </p>
          <p>
            More online security features than any other big broadband provider.
          </p>
          <p>
            <strong>
              Keep your family safe online and protect the things that matter
            </strong>
          </p>
          <p>
            Safe as standard. Get peace of mind that everything that’s important
            to you is secure online with Wi-Fi controls, parental controls and
            BT Cloud.
          </p>
        </div>
        <div className="columns">
          <div className="logo">
            <img src="images/marketing/BT_strong-man.png" alt="" />
          </div>
          <div />
          <h3>Beyond Strong</h3>
          <p>
            <strong>The UK’s most powerful hub​</strong>
          </p>
          <p>
            Our Smart Hubs have the UK’s most powerful Wi-Fi signal compared to
            other big broadband providers.
          </p>
          <p>
            <strong>Guaranteed Wi-Fi in every room</strong>
          </p>
          <p>
            A strong Wi-Fi signal reaching every room in he home. Guaranteed
            with Complete Wi-Fi.​
          </p>
        </div>
      </div>
      <div className="row info-table ">
        <div className="table-column">
          <img src="images/marketing/BT_headset.png" alt="" />
          <p>
            You’ll always speak to one of our team based in the UK & Ireland
            when you call us
          </p>
        </div>
        <div className="table-column">
          <img src="images/marketing/BT_tools.png" alt="" />
          <p>Fast repair and 2 hr appointments slots, 7 days a week</p>
        </div>
        <div className="table-column">
          <img src="images/marketing/BT_customer_service.png" alt="" />
          <p>Expert help right to your doorstep with our Home Tech Experts</p>
        </div>
        <div className="table-column">
          <img src="images/marketing/BT_store_front.png" alt="" />
          <p>Get help in one of our 640 stores across the UK</p>
        </div>
      </div>
      <div className="marketing-button-container">
        <Button text="Back" onClick={handleBackButtonClick} />
        <Button text="Continue" onClick={handleButtonClick} />
      </div>
    </div>
  </div>
)

MarketingBT2.propTypes = {
  handleButtonClick: PropTypes.func.isRequired
}

export default MarketingBT2
